import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ConfirmPopup from '../../../components/shared/ConfirmPopup';
import { Colors } from '../../../themes/colors';
import CandidateSortAnnouncement from '../../../images/candidate-sort-announcement.svg';

export function CandidateSortAnnouncementPopup() {
  const user = useSelector((state) => state.user.selectedChildOffice ?? state.user.user);
  const [showPopup, setShowPopup] = useState(false);

  const getStorage = useCallback(() => {
    if (!user) {
      return;
    }

    const popupAppeared = localStorage.getItem(`candidateSortAnnouncement-${user.id}`);

    if (popupAppeared === null) {
      setShowPopup(true);
    }
  }, [user]);

  const setStorage = useCallback(() => {
    if (!user) {
      return;
    }

    localStorage.setItem(`candidateSortAnnouncement-${user.id}`, 'false');
    setShowPopup(false);
  }, [user]);

  useEffect(() => {
    getStorage();
  }, []);

  if (!showPopup) {
    return null;
  }

  return (
    <ConfirmPopup
      dataCy="candidate-sort-announcement-modal"
      rightButtonDataCy="btn-got-it"
      modalStyle={{ maxWidth: 500, maxHeight: 560, paddingTop: 57 }}
      Icon={() => (
        <img
          alt="CandidateSortAnnouncement"
          src={CandidateSortAnnouncement}
          style={{ marginBottom: 30 }}
        />
      )}
      title="Confirm Candidate New Feature!"
      titleStyle={{ color: Colors.primary_500, fontSize: 20, marginBottom: 16 }}
      description={
        <div>
          You can now see even more candidates for a shift, and it’s even easier to find exactly the
          right professional for the job.
          <br />
          <br />
          Click the arrow on the right of your candidates to see more, and use the new ‘Sort By’
          dropdown to help get closer to what you’re looking for.
        </div>
      }
      descriptionStyle={{ color: Colors.neutral_500, marginBottom: 42, width: '85%' }}
      rightButtonText="Got It!"
      rightButtonAction={setStorage}
    />
  );
}
